import { PartialTheme } from "../types";
import { amcFonts, amcSemanticColors } from "./AmcTheme";

export const amcOnRedTheme: PartialTheme = {
    palette: {
        themePrimary: "#a80000",
        neutralLight: "#f4cfc2",
        neutralDark: "#323130",
        neutralSecondary: "#323130",
        neutralTertiaryAlt: "#e9c4b7",
        themeDarkAlt: "#901619",
        themeDark: "#790C0E"
    },
    semanticColors: amcSemanticColors,
    fonts: amcFonts
};
